import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';

const columns = [{ id: 'extension', label: '확장자', minWidth: 40, align: 'center' }];
const extensionColumns = [{ id: 'extension', label: '확장자', minWidth: 140, align: 'center' }];

export default function ExtensionReference() {
  const [datas, setDatas] = useState({});
  const [rows, setRows] = useState([]);
  const [subExtension, setSubExtension] = useState('');
  const [extensionRows, setExtensionRows] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
    setSubExtension('');
  };

  const getDataList = async (e) => {
    await axios.get(`/api/didas/extension`).then((response) => {
      if (response.data.extList) {
        setRows(response.data.referenceList);
      }
    });
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    clearErrors();
    reset();
  };

  const createOrUpdate = async (datas) => {
    if (!!datas.id) {
      return await extensionUpdate(datas);
    } else {
      return await extensionCreate(datas);
    }
  };

  const extensionCreate = async (data) => {
    const params = { extension: data.extension, name: 'reference' };
    await axios
      .post(`/api/didas/extension`, params)
      .then(async (response) => {
        alert(response.data.message);
        getDataList();
        initForm();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const extensionUpdate = async (data) => {
    const params = { id: data.id, extension: data.extension, name: 'reference' };
    await axios
      .patch(`/api/didas/extension`, params)
      .then(async (response) => {
        alert(response.data.message);
        getDataList();
        initForm();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const onSubmit = async (data) => {
    if (isDirty) {
      createOrUpdate(data.datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .delete(`/api/didas/extension/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const handleChangeExtension = (e) => {
    setSubExtension(e.target.value);
  };

  const onClickExtensionSave = async (evt) => {
    if (datas.id && subExtension) {
      const params = { extension: subExtension, parentId: datas.id, name: 'reference' };
      await axios
        .post(`/api/didas/extension`, params)
        .then(async (response) => {
          alert(response.data.message);
          await getExtensionList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const onClickExtensionDelete = async (row) => {
    if (window.confirm('참조 확장자를 삭제하시겠습니까?')) {
      await axios
        .delete(`/api/didas/extension/${row.id}`, { params: row })
        .then(async (response) => {
          alert(response.data.message);
          await getExtensionList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getExtensionList = async (e) => {
    await setSubExtension();
    await setExtensionRows([]);
    await axios.get(`/api/didas/extension/reference/${datas.id}`).then((response) => {
      if (response.data.extList) {
        setExtensionRows(response.data.referenceList);
      }
    });
  };

  useEffect(() => {
    if (datas.id) getExtensionList();
  }, [datas.id]);

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        참조
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="ExtensionReferenceForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              {!!datas.id ? '수정' : '등록'}
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas.id ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="ExtensionReferenceForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              name="extension"
              label="확장자"
              id="extension"
              value={datas?.extension || ''}
              error={!!errors.datas?.extension}
              helperText={errors.datas?.extension && errors.datas?.extension.message}
              {...register('datas.extension', {
                required: '확장자를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
          </Box>
          {datas.id && (
            <>
              <Divider sx={{ mt: 2, mb: 1 }} />
              <FormLabel>참조 확장자</FormLabel>
              <br />
              <TextField
                size="small"
                margin="dense"
                name="subExtension"
                label="참조 확장자"
                id="subExtension"
                value={subExtension || ''}
                error={!!errors.subExtension}
                helperText={errors.subExtension && errors.subExtension.message}
                {...register('subExtension', { onChange: (e) => handleChangeExtension(e) })}
              />
              <Button variant="contained" onClick={onClickExtensionSave} sx={{ mt: '8px', ml: 1 }}>
                등록
              </Button>
              <TableContainer component={'div'}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {extensionColumns.map((column) => (
                        <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {extensionRows.map((row, rowIdx) => (
                      <TableRow hover key={row.id + 'ext'} onClick={() => onClickExtensionDelete(row)}>
                        {extensionColumns.map((col, colIdx) => (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row[col.id]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}
